import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context';
import MFAEnrollmentGate from '@/components/MFAEnrollmentGate';

export interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, isLoading, error, authReady } = useAuth() as {
    user: { uid: string; displayName?: string; email?: string } | null;
    isLoading: boolean;
    error: unknown;
    authReady: boolean;
  };

  // Show loading state while auth is being determined
  if (isLoading || !authReady) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <p className="text-slate-500 dark:text-slate-400">Verifying credentials...</p>
      </div>
    );
  }

  // Handle authentication errors
  if (error) {
    console.error('Auth error:', error);
    return (
      <div className="flex justify-center items-center min-h-screen text-red-600">
        <p>Error loading authentication.</p>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // User is authenticated — enforce MFA for clinical roles before rendering
  return <MFAEnrollmentGate>{children}</MFAEnrollmentGate>;
};

export default ProtectedRoute;
